import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppView } from '../common/constants';

interface NavState {
  view: AppView;
  tenantId: string | null;
  selectedDashboardTenantNames: string[];
}

//  No localStorage hydration — plain defaults only
const initialState: NavState = {
  view: 'tenant',
  tenantId: null,
  selectedDashboardTenantNames: [],
};

const navSlice = createSlice({
  name: 'nav',
  initialState,
  reducers: {
    goDashboard(state) {
      state.view = 'dashboard';
    },
    goTenant(state, action: PayloadAction<string | undefined>) {
      state.view = 'tenant';
      if (action.payload) {
        state.tenantId = action.payload;
      }
    },
    setTenantId(state, action: PayloadAction<string>) {
      state.tenantId = action.payload;
      // keep user in the tenant view when they pick a tenant
      if (state.view !== 'tenant') {
        state.view = 'tenant';
      }
    },
    setSelectedTenantNames(state, action: PayloadAction<string[]>) {
      state.selectedDashboardTenantNames = action.payload;
      // For dashboard view with multi-select, don't change view
      // For tenant view with single select, update tenantId as well
      if (state.view === 'tenant' && action.payload.length === 1) {
        state.tenantId = action.payload[0];
      }
    },
  },
});

// Selectors
export const selectSelectedDashboardTenantNames = (state: { nav: NavState }) => state.nav.selectedDashboardTenantNames;

export const { goDashboard, goTenant, setTenantId, setSelectedTenantNames } = navSlice.actions;
export default navSlice.reducer;
